import { Injectable } from '@angular/core';
import { EmissionService } from 'services/emission.service';
import { Constants } from 'config/constants';
import { UnsavedCar } from 'models/unsavedCar';


@Injectable()
export class BusinessFleetService {
    private category = Constants.categories.business.fleet;

    private lastUnsavedCar: UnsavedCar = null;

    private vehicleList: Array<{title, emission, emissionTrees, DollarAmt, DollarAmtMonthly}> = [];

    constructor(private emissionService: EmissionService) {
    }

    setLastUnsavedCar(year = null, make = null, model = null, mileage = null) {
        if (year && make && model && mileage) {
            this.lastUnsavedCar = new UnsavedCar(year, make, model, mileage);
        } else {
            this.lastUnsavedCar = null;
        }
    }

    getLastUnsavedCar() {
        return this.lastUnsavedCar;
    }

    addToVehicleList(vehicle: {title, emission, emissionTrees, DollarAmt, DollarAmtMonthly}) {
        this.vehicleList.push(vehicle);
        this.sendEmissionToDashboard();
    }

    getVehicleList() {
        return this.vehicleList;
    }

    deleteFromVehicleList(index: number): void {
        this.vehicleList.splice(index, 1);
        this.sendEmissionToDashboard();
    }

    getTotalEmission(): void {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        let vehicleListLength = this.vehicleList.length;

        if (vehicleListLength === 1) {
            this.vehicleList.map(item => {
                emission += item.emission;
                emissionTrees += item.emissionTrees;
                DollarAmt += item.DollarAmt;
                DollarAmtMonthly += item.DollarAmtMonthly;
            });

            this.sendPreparedDataToDashboard({
                emission,
                emissionTrees,
                DollarAmt,
                DollarAmtMonthly
            });
        } else {
            this.getTotalPrice();
        }
    }

    getTotalPrice(): void {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        this.vehicleList.map(item => {
            emission += item.emission;
        });
        this.emissionService.getTotalPrice(emission).subscribe(
            response => {
                let input = response[0];
                emissionTrees = input.emissionTrees;
                DollarAmt = input.DollarAmt;
                DollarAmtMonthly = input.DollarAmtMonthly;

                this.sendPreparedDataToDashboard({
                    emission,
                    emissionTrees,
                    DollarAmt,
                    DollarAmtMonthly
                });
            }
        );
    }

    sendPreparedDataToDashboard(emission: {emission, emissionTrees, DollarAmt, DollarAmtMonthly}): void {
        this.emissionService.setEmission({
            category: this.category,
            emission: emission
        });
    }

    public cleanVehicleList(): void {
        this.lastUnsavedCar = null;
        this.vehicleList = [];
    }

    sendEmissionToDashboard(): void {
        this.getTotalEmission();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/calculator-items/business-fleet.service.ts